export default __webpack_public_path__ + "static/broderie.en.cover-4be1b7e4762ce2157590e4b220c45c56.jpg";